import HelpIcon from "@mui/icons-material/Help";
import { blue, Tooltip } from "@flat-ui";

interface Props {
  /** The content to show when hovering over the question mark icon */
  title: React.ReactNode;
}

/** Component showing a question mark icon that will show the provided title on hover */
export function HelpIconTooltip({ title }: Props): React.JSX.Element {
  return (
    <Tooltip title={title}>
      <span>
        <HelpIcon
          sx={{
            color: blue[500],
            cursor: "pointer",
          }}
        />
      </span>
    </Tooltip>
  );
}
